import { useTranslation } from 'react-i18next';
import { SILENT_RENEW_PAGE_NS } from './i18n';

export const SilentRenewPage: React.FC = () => {
  const { t } = useTranslation(SILENT_RENEW_PAGE_NS);
  console.log('Silent Renew', { ...window.location });
  return <h1>{t('refreshing', { path: window.location.search })}</h1>;
};
